import React from "react";
import { Card } from "react-bootstrap";
import { TextField, Button, Typography } from "@mui/material";

const GoogleMap = ({formData, coordinate, setCoordinate, googleLocation, setGoogleLocation }) => {
  const handleOpenMapLocation = () => {
    const encodedLocation = encodeURIComponent(googleLocation);
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedLocation}`;
    window.open(googleMapsUrl, "_blank");
  };

  const handleOpenMapCoordinate = () => {
    console.log("inside handle coordinate change");

    const { latitude, longitude } = coordinate[0]; // Accessing the first (and presumably only) coordinate
    const googleMapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
    window.open(googleMapsUrl, "_blank");
  };

  const handleCoordinateChange = (field, value) => {
    console.log("inside handle coordinate change");

    setCoordinate((prev) => {
      const newCoordinates = [...prev]; // Copy the existing array
      newCoordinates[0] = { ...newCoordinates[0], [field]: value }; // Update the first coordinate
      return newCoordinates; // Return the updated array
    });
  };

  const handleGoogleLocation = (e) => {
    setGoogleLocation(e.target.value);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
      <Typography variant="h4" gutterBottom>
        View On Maps
      </Typography>
      <Card style={{ padding: "20px", maxWidth: "750px", width: "100%" }}>
        <div style={{ display: "flex", width: "100%" }}>
          {/* Location Section */}
          <div style={{ flex: 1, marginRight: "10px" }}>
            <TextField
              label="Enter Location to View on Map"
              type="text"
              value={googleLocation || formData?.descriptionOfLand?.googleMapLocation}
              onChange={handleGoogleLocation}
              fullWidth
              margin="normal"
              variant="outlined"
              defaultValue={formData?.descriptionOfLand?.googleMapLocation}
            />
            <Button variant="contained" color="primary" onClick={handleOpenMapLocation} style={{ width: "100%", marginTop: "91px" }}>
              View On Maps
            </Button>
          </div>

          {/* Vertical Line */}
          <div style={{ width: "1px", backgroundColor: "#ccc", height: "auto", margin: "0 20px" }}></div>

          {/* Coordinate Section */}
          <div style={{ flex: 1, marginLeft: "10px" }}>
            <div style={{ display: "flex", flexDirection: "column", width: "100%", marginBottom: "20px" }}>
              <TextField
                label="Latitude"
                type="number"
                value={coordinate[0]?.latitude || formData?.descriptionOfLand?.googleMapCoordinates?.[0]?.latitude} // Safe access with fallback
                onChange={(e) => handleCoordinateChange("latitude", e.target.value)}
                fullWidth
                margin="normal"
                variant="outlined"
                inputProps={{ step: "any" }}
                defaultValue={formData?.descriptionOfLand?.googleMapCoordinates?.[0]?.latitude}
              />
              <TextField
                label="Longitude"
                type="number"
                value={coordinate[0]?.longitude || formData?.descriptionOfLand?.googleMapCoordinates?.[0]?.longitude} // Safe access with fallback
                onChange={(e) => handleCoordinateChange("longitude", e.target.value)}
                fullWidth
                margin="normal"
                variant="outlined"
                inputProps={{ step: "any" }}
                style={{ marginTop: "10px" }}
                defaultValue={formData?.descriptionOfLand?.googleMapCoordinates?.[0]?.longitude}
              />
              <Button variant="contained" color="primary" onClick={handleOpenMapCoordinate} style={{ width: "100%", marginTop: "20px" }}>
                View On Maps
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default GoogleMap;
